import { useRef } from 'react'
import { useOnClickOutside } from '@/hooks'
import { useGlobalDrawerStore } from '@/stores/useGlobalDrawerStore/useGlobalDrawerStore'
import { OverlayDrawer } from '@molecules'

export const GlobalDrawer = () => {
    const { isOpen, title, content, closeDrawer } = useGlobalDrawerStore(
        (state) => state
    )

    const containerRef = useRef<HTMLDivElement>(null)

    useOnClickOutside(containerRef, closeDrawer)

    return (
        <OverlayDrawer
            name="global-drawer"
            isOpen={isOpen}
            title={title}
            content={content}
            containerRef={containerRef}
            onClose={(event) => {
                event.preventDefault()
                event.stopPropagation()
                closeDrawer()
            }}
        />
    )
}
